module.exports = __webpack_public_path__ + "img/1583614660.727532cd.jpg";